export default {
  xs: 310,
  sm: 475,
  md: 768,
  lg: 1140,
  xl: 1300,
  xxl: 1500
}